import {ESerialMode, FactoryRegistry, Serializable} from "lib/commons/io/serial";
import {ENodeType} from "lib/commons/xml/dom";

/**
 * Règle de sélection d'un noeud fils associé à une {SkRule}.
 */
export abstract class SkMatcherNode extends Serializable {
	static readonly registry = new FactoryRegistry<SkMatcherNode>("SkMatcherNode");

	/**
	 * Expression xpath relatif à son contexte parent.
	 */
	techName: string;

	isFuzzy(): boolean {return false}

	/** Nom de l'élément ou début du nom si le nom est fuzzy. */
	get startName(): string {return null}

	abstract matchNode(nodeType: ENodeType, nodeName?: string): boolean;
}

//
// class SkMatcherEltNameNs extends SkMatcherNode {
// 	static readonly type = "ns";
//
// 	localName: string;
// 	ns: string;
//
// 	constructor(localName, ns, name) {
// 		super();
// 		this.localName = localName;
// 		this.ns = ns;
// 		this.techName = name || localName;
// 	}
//
// 	matchNode(node) {
// 		if (node.localName !== this.localName) return false;
// 		return node.namespaceURI === this.ns;
//
// 	}
//
// 	writeTo(o: any, mode: ESerialMode) {
// 		o.n = this.localName;
// 		o.ns = this.ns;
// 	}
//
// 	readFrom(o: any, mode: ESerialMode): this {
// 		this.name = o.n;
// 		this.ns = o.ns;
// 		return this;
// 	}
// }
// SkMatcherNode.registry.register(SkMatcherEltNameNs);

export class SkMatcherEltName extends SkMatcherNode {
	static readonly type = "n";

	constructor(name: string) {
		super();
		this.techName = name;
	}

	matchNode(nodeType: ENodeType, nodeName: string) {return nodeType == ENodeType.element && (nodeName == null || nodeName === this.techName)}

	get startName(): string {return this.techName}

	writeTo(o: any, mode: ESerialMode) {
		o.n = this.techName;
	}

	readFrom(o: any, mode: ESerialMode): this {
		this.techName = o.n;
		return this;
	}
}

SkMatcherNode.registry.register(SkMatcherEltName);

export class SkMatcherAnyElt extends SkMatcherNode {
	static readonly type = "*";
	static readonly SINGLETON = Object.freeze(new SkMatcherAnyElt());

	matchNode(nodeType: ENodeType, nodeName: string) {return nodeType === Node.ELEMENT_NODE}

	// @ts-ignore
	get techName() {return "*"}

	get startName(): string {return ""}

	isFuzzy(): boolean {return true}

	writeTo(o: any, mode: ESerialMode) {
	}

	readFrom(o: any, mode: ESerialMode): this {
		return SkMatcherAnyElt.SINGLETON as this;
	}
}

SkMatcherNode.registry.register(SkMatcherAnyElt);

export class SkMatcherEltNs extends SkMatcherNode {
	static readonly type = "ns";

	ns: string;
	prefix: string;

	constructor(ns: string, prefix: string) {
		super();
		this.prefix = prefix;
		this.ns = ns;
	}

	matchNode(nodeType: ENodeType, nodeName: string) {
		return nodeType == ENodeType.element && (nodeName == null || this.prefix ? nodeName.startsWith(this.prefix) && nodeName.charAt(this.prefix.length) === ':' : nodeName.indexOf(':') < 0);
	}

	get startName(): string {return this.prefix ? this.prefix + ":" : ""}

	// @ts-ignore
	get techName(): string {return this.prefix ? this.prefix + ":*" : "*"}

	isFuzzy(): boolean {return true}

	writeTo(o: any, mode: ESerialMode) {
		o.prefix = this.prefix;
		o.ns = this.ns;
	}

	readFrom(o: any, mode: ESerialMode): this {
		this.prefix = o.prefix;
		this.ns = o.ns;
		return this;
	}
}

SkMatcherNode.registry.register(SkMatcherEltNs);

export class SkMatcherEltChoice extends SkMatcherNode {
	static readonly type = "choice";
	subMatchers: SkMatcherNode[] = [];

	matchNode(nodeType: ENodeType, nodeName: string) {return this.subMatchers.some(s => s.matchNode(nodeType, nodeName))}

	get startName(): string {return this.subMatchers[0].startName}

	// @ts-ignore
	get techName(): string {return this.subMatchers.map(s => s.techName).join("|")}

	isFuzzy(): boolean {return true}

	writeTo(o: any, mode: ESerialMode) {
		o.sub = Serializable.serialArraySerializables(this.subMatchers, mode);
	}

	readFrom(o: any, mode: ESerialMode): this {
		this.subMatchers = Serializable.deserialArraySerializables(o.sub, mode, SkMatcherNode.registry);
		return this;
	}
}

SkMatcherNode.registry.register(SkMatcherEltChoice);

export class SkMatcherDoc extends SkMatcherNode {
	static readonly type = "/";

	static readonly SINGLETON = Object.freeze(new SkMatcherDoc());

	matchNode(nodeType: ENodeType, nodeName: string) {return nodeType === Node.DOCUMENT_NODE || nodeType === Node.DOCUMENT_FRAGMENT_NODE}

	// @ts-ignore
	get techName() {return "/"}

	writeTo(o: any, mode: ESerialMode) {
	}

	readFrom(o: any, mode: ESerialMode): this {
		return SkMatcherDoc.SINGLETON as this;
	}
}

SkMatcherNode.registry.register(SkMatcherDoc);

export class SkMatcherText extends SkMatcherNode {
	static readonly type = "#";
	static readonly SINGLETON = Object.freeze(new SkMatcherText());

	matchNode(nodeType: ENodeType, nodeName: string) {return nodeType === Node.TEXT_NODE}

	// @ts-ignore
	get techName() {return "text()"}

	writeTo(o: any, mode: ESerialMode) {}

	readFrom(o: any, mode: ESerialMode): this {
		return SkMatcherText.SINGLETON as this;
	}
}

SkMatcherNode.registry.register(SkMatcherText);

export class SkMatcherComment extends SkMatcherNode {
	static readonly type = "!";
	static readonly SINGLETON = Object.freeze(new SkMatcherComment());

	matchNode(nodeType: ENodeType, nodeName: string) {return nodeType === Node.COMMENT_NODE}

	// @ts-ignore
	get techName() {return "comment()"}

	writeTo(o: any, mode: ESerialMode) {
	}

	readFrom(o: any, mode: ESerialMode): this {
		return SkMatcherComment.SINGLETON as this;
	}
}

SkMatcherNode.registry.register(SkMatcherComment);


/**
 * Règle de sélection d'un attribut associé à une {SkRule}.
 */
export abstract class SkMatcherAttr extends Serializable {
	static readonly registry = new FactoryRegistry<SkMatcherAttr>("SkMatcherAttr");

	/**
	 * Nom technique de l'attribut "@myAtt" ou expression fuzzy du type "@xx:*", "@*"...
	 */
	techName: string;

	abstract isFuzzy(): boolean;

	/** Nom de l'attribut ou début du nom si le nom est fuzzy. */
	startName: string;

	abstract matchAttr(attr: string): boolean;
}

export class SkMatcherAttrName extends SkMatcherAttr {
	static readonly type = "n";

	constructor(nodeName: string) {
		super();
		this.startName = nodeName;
		this.techName = "@" + nodeName;
	}

	isFuzzy() {return false}

	matchAttr(attrName: string) {
		return attrName === this.startName;
	}

	writeTo(o: any, mode: ESerialMode) {
		o.n = this.techName;
	}

	readFrom(o: any, mode: ESerialMode): this {
		this.techName = o.n;
		return this;
	}
}

SkMatcherAttr.registry.register(SkMatcherAttrName);

export class SkMatcherAnyAttr extends SkMatcherAttr {
	static readonly type = "*";

	static readonly SINGLETON = Object.freeze(new SkMatcherAnyAttr());

	// @ts-ignore
	get techName() {return "@*"}

	// @ts-ignore
	get startName() {return ""}

	isFuzzy() {return true}

	matchAttr(attr: string) {return true}

	writeTo(o: any, mode: ESerialMode) {}

	readFrom(o: any, mode: ESerialMode): this {
		return SkMatcherAnyAttr.SINGLETON as this;
	}
}

SkMatcherAttr.registry.register(SkMatcherAnyAttr);
